export const ENV_PUBLIC = Object.create(window.appEnv)
